import { Injectable, Inject, Optional } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { AuthService } from '../nenomed-main/services/auth.service';
import { environment } from '../nenomed-main/environments/environment';
import { BehaviorSubject, Observable, catchError, filter, switchMap, take, throwError } from 'rxjs';

@Injectable()
export class UniversalInterceptor implements HttpInterceptor {

  private isRefreshing = false;
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
      null
    );
    
  constructor(private auth: AuthService) {}

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      const user = JSON.parse(localStorage.getItem('nenomed-user')!);
      
      return this.auth.StudiaRefreshToken(user.jwtToken, user.refreshToken).pipe(
        switchMap((token: any) => {
          this.isRefreshing = false;
          localStorage.setItem('nenomed-user', JSON.stringify(token));
          this.refreshTokenSubject.next(token.jwtToken);
          return next.handle(this.addToken(request, token.jwtToken));
        })
      );
    } else {
     
      return this.refreshTokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((jwt) => {
          return next.handle(this.addToken(request, jwt));
        })
      );
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    let serverReq: HttpRequest<any> = req;
    // if (this.request) {
    //   let newUrl = `${this.request.protocol}://${this.request.get('host')}`;
    //   if (!req.url.startsWith('/')) {
    //     newUrl += '/';
    //   }
    //   newUrl += req.url;
    //   serverReq = req.clone({url: newUrl});
    // }
    
    if(this.auth.isLoggedIn)
      {        
          const account = this.auth.userData;
          const isLoggedIn = true;
          const isApiUrl = (serverReq.url.startsWith(environment.netCoreApiUrl) || serverReq.url.startsWith(environment.nenomedCloudUrl) || serverReq.url.startsWith(environment.nenomedApiUrl));
          
          if (isLoggedIn && isApiUrl) {

              const user = JSON.parse(localStorage.getItem('nenomed-user')!);
      
              serverReq = serverReq.clone({
                  setHeaders: { Authorization: `Bearer ${user.AUTH_TOKEN}`, token:  `${user.AUTH_TOKEN}`}
              });
          }
      }

    return next.handle(serverReq).pipe(
      catchError((error:any) => {
        console.log("EEERRR",error);
        
       

          if (error instanceof HttpErrorResponse && error.status === 401 && error.error!='Invalid attempt!') {
          return this.handle401Error(serverReq, next);
          } else {
          return throwError(()=>error);
          }
      })
      );
  }
}
